








































































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { Mutation, State, Getter, Action } from 'vuex-class';
import DeleteModal from '@/components/DeleteModal.vue';
import { IRepresentative, IUser } from '../../models';
import { BaseDetail } from '../Base/BaseDetail';

const namespace = 'representative';
const ns = { namespace };

@Component
export default class RepresentativeDetail extends BaseDetail<IRepresentative> {
  @Prop({ default: () => ({}) }) readonly preDefinedValues: any;
  namespace = namespace;
  positions = [];
  types = [];
  @State('entities', ns) entities: Record<string, IRepresentative>;
  @State('currentUser', { namespace: 'user' }) currentUser: IUser;
  @Action('createEntity', ns) createEntity: any;
  @Action('getEntity', ns) getEntity: any;
  @Action('updateEntity', ns) updateEntity: any;
  @Action('deleteEntity', ns) deleteEntity: any;

  mounted() {
    this.loadEntity()?.then(() => {
      this.setValue(this.entityPatch, 'id', Number(this.entityId));
    });
    if (this.preDefinedValues) {
      for (const [key, value] of Object.entries(this.preDefinedValues)) {
        this.setValue(this.entityPatch, key, value);
      }
    }
  }
}
